import React from "react";
import { useTranslation } from 'react-i18next';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

export default function IMEIHelp() {
    const { t } = useTranslation();

    return (
        <Typography variant="caption">
            {t('IMEI.HelpTextStart')}
            &nbsp;
            <Link href="tel:*#06#">*#06#</Link>
            &nbsp;
            {t('IMEI.HelpTextEnd')}
        </Typography>
    );
}